import { css } from '@/styled-system/css';

export const row = css({
  display: 'flex',
  alignItems: 'stretch',
  gap: 'tighter',
  width: '100%',
  marginTop: 'loose',
});
